import React, { useState, createElement } from 'react';
import { RatingStars } from './ui/RatingStars';
import { ArrowRight } from 'lucide-react';
// Declare Calendly type for TypeScript
declare global {
  interface Window {
    Calendly: {
      initPopupWidget: (options: {
        url: string;
      }) => void;
    };
  }
}
export function VerdictSection() {
  const [calendlyLoaded, setCalendlyLoaded] = useState(false);
  // Lazy load Calendly only when user interacts with button
  const loadCalendly = () => {
    if (calendlyLoaded) return;
    // Load Calendly CSS
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    // Load Calendly JS
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = () => setCalendlyLoaded(true);
    document.body.appendChild(script);
  };
  const handleCalendlyClick = () => {
    if (!calendlyLoaded) {
      loadCalendly();
      // Wait a bit for script to load, then open
      setTimeout(() => {
        if (window.Calendly) {
          window.Calendly.initPopupWidget({
            url: 'https://calendly.com/justus-kraft/crm-automatisierung-demo-website?hide_gdpr_banner=1'
          });
        }
      }, 500);
    } else if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/justus-kraft/crm-automatisierung-demo-website?hide_gdpr_banner=1'
      });
    }
  };
  return <section className="py-16 bg-slate-900 text-white rounded-t-3xl md:rounded-3xl my-8 md:mx-4 lg:mx-8" data-id="element-167">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-168">
        <h2 className="text-3xl font-bold mb-6" data-id="element-169">Unser Fazit</h2>

        <div className="flex justify-center mb-6" data-id="element-170">
          <div className="bg-slate-800 p-4 rounded-xl border border-slate-700 inline-flex items-center gap-4" data-id="element-171">
            <span className="text-2xl font-bold" data-id="element-172">4.5</span>
            <RatingStars rating={4.5} size="lg" data-id="element-173" />
            <span className="text-slate-400 border-l border-slate-600 pl-4" data-id="element-174">
              Exzellent
            </span>
          </div>
        </div>

        <p className="text-xl text-slate-300 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-175">
          CRM Kraft ist keine Standard-Lösung von der Stange, sondern ein
          hochspezialisierter Partner für Unternehmen, die mit{' '}
          <strong data-id="element-176">Close CRM</strong> ernsthaft wachsen wollen. Die Kombination
          aus technischer IT-Expertise und echtem Vertriebs-Know-how ist in
          dieser Form selten zu finden.
        </p>

        <div className="bg-slate-800/50 rounded-lg p-6 mb-10 text-left max-w-2xl mx-auto border border-slate-700" data-id="element-177">
          <h3 className="font-bold text-white mb-2" data-id="element-178">
            Besonders empfohlen für:
          </h3>
          <ul className="list-disc list-inside text-slate-300 space-y-1" data-id="element-179">
            <li data-id="element-180">B2B-Unternehmen mit Vertriebsteams</li>
            <li data-id="element-181">Unternehmen, die manuelle Prozesse automatisieren wollen</li>
            <li data-id="element-182">Teams, die datenbasierte Entscheidungen treffen möchten</li>
          </ul>
        </div>

        <button onClick={handleCalendlyClick} className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-4 px-8 rounded-lg transition-all transform hover:scale-105 shadow-lg hover:shadow-blue-500/25 flex items-center mx-auto" data-id="element-183">
          Kostenlose Erstberatung vereinbaren
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-184" />
        </button>
        <p className="mt-4 text-sm text-slate-500" data-id="element-185">
          Keine Kreditkarte erforderlich • Unverbindliches Gespräch
        </p>
      </div>
    </section>;
}